import {
  Directive,
  ViewContainerRef,
  AfterViewInit,
  signal,
  Injector,
  model,
  input,
  computed,
  linkedSignal,
  effect,
} from '@angular/core';
import VectorLayer from 'ol/layer/Vector';
import { Feature } from 'ol';
import {
  Difference,
  Intersect,
  Intersects,
} from 'src/app/shared/helpers/transformations';
import { IntersectButtonComponent } from './intersect-button.component';

@Directive({
  selector: '[intersectTool]',
  standalone: true,
})
export class IntersectToolDirective implements AfterViewInit {
  readonly active = signal<boolean>(true);
  intersectTargetLayers = input<Array<VectorLayer<any>>>([]);
  intersectTargetFeatures = input<Array<Feature<any>>>([]);

  intersectTargets = computed(() => {
    const targetLayers = this.intersectTargetLayers();
    const targetFeatures = this.intersectTargetFeatures();


    return [...targetFeatures,  ...targetLayers.flatMap((lyr) => lyr.getSource().getFeatures())]
  });

  constructor(
    private vcr: ViewContainerRef,
    private parentInjector: Injector
  ) {}

  ngAfterViewInit(): void {
    const childInjector = Injector.create({
      providers: [{ provide: IntersectToolDirective, useValue: this }],
      parent: this.parentInjector,
    });

    this.vcr.createComponent(IntersectButtonComponent, {
      injector: childInjector,
    });
  }

  execute(target: Feature<any>) {
    if (target == null) {
      return;
    }

    if (!this.active()) return;

    const intersectTargets = this.intersectTargets();

    for (let index = 0; index < intersectTargets.length; index++) {
      const feature = intersectTargets[index];

      if (!Intersects(target, feature)) return;

      const clippedFeature = Intersect(target, feature);
      target.setGeometry(clippedFeature.getGeometry());
    }
  }

  toggle(): void {
    this.active.update((v) => !v);
  }
}
